import {createSelector} from 'reselect';
import GlobalState from '../../../root-state';

const selectResume = (state : GlobalState) => state.servers.resume;

export const serversResumeSelector = createSelector(
    [selectResume],
    data => data
)
